// Sajtens metadata: kursfakta (kurs.json/kursFallback) + publiceringsinställningar
// (site.config.json) — synkade till src/content/site.json av scripts/sync-content.mjs.
// Enda stället där kursnamn/domän/licens ska läsas ifrån; hårdkoda dem aldrig i
// komponenter, entry-server.tsx eller prerender.mjs.
import site from '../content/site.json'

export const KURSNAMN = site.kursnamn
export const KURSKOD = site.kurskod
export const NIVA = site.niva
export const POANG = site.poang
export const AMNESKATEGORI = site.amneskategori
export const SAJT_URL = site.sajtUrl
export const LICENS = site.licens
export const KONTAKT_EPOST = site.kontaktEpost

export const SAJTNAMN = `${KURSNAMN} — digitalt läromedel`

/** Kort märke i sidhuvudets logotyp — kurskoden (t.ex. "VAXD") om den finns,
 *  annars kursnamnets versalinitialer (max två bokstäver). */
export const LOGOTYP_FORKORTNING =
  KURSKOD ||
  KURSNAMN.split(/\s+/)
    .filter((ord) => /^[A-ZÅÄÖ]/.test(ord))
    .slice(0, 2)
    .map((ord) => ord[0])
    .join('') ||
  '?'

/** "100 poäng" om poängtalet är känt, annars tom sträng — för meningar som
 *  annars skulle bli "(poäng, ämneskod )" när källan saknar kurs.json. */
export const POANG_TEXT = POANG ? `${POANG} poäng` : ''
